import { Component, DestroyRef, inject, Input, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { OnboardingService } from '../onboarding.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ArivoLicensePlateInputComponent } from '../../../../shared/components/ui-components/arivo-license-plate-input/arivo-license-plate-input.component';
import { ArivoStepperComponent } from '../../../../shared/components/ui-components/arivo-stepper/arivo-stepper.component';
import { LicensePlate } from '../../../../shared/models/licensePlate';
import { requireLicensePlate } from '../../../../shared/utils/form.utils';
import { pairwise, take } from 'rxjs';
import { showSpinner } from '../../../../shared/utils/common.utils';
import { ToastService } from '../../../../shared/services/toast.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-onboarding-first-step',
  templateUrl: './onboarding-first-step.component.html',
  styleUrl: './onboarding-first-step.component.scss',
})
export class OnboardingFirstStepComponent {
  private destroyRef = inject(DestroyRef);
  @ViewChild(ArivoLicensePlateInputComponent) licensePlateInputComponent!: ArivoLicensePlateInputComponent;

  @Input() stepperComponent?: ArivoStepperComponent;

  constructor(
    private _formBuilder: FormBuilder,
    private onboardingService: OnboardingService,
    private toastService: ToastService,
    private translateService: TranslateService,
  ) {
    this.licensePlateForm
      .get('licensePlate')
      ?.valueChanges.pipe(pairwise(), takeUntilDestroyed(this.destroyRef))
      .subscribe(([oldPlate, newPlate]: [LicensePlate | null, LicensePlate | null]) => {
        if (oldPlate?.license_plate !== newPlate?.license_plate || oldPlate?.license_plate_country !== newPlate?.license_plate_country) {
          if (newPlate) {
            this.licensePlateForm.get('confirmRights')?.setValue(false);
          }
        }
      });
  }

  licensePlateForm = this._formBuilder.group({
    licensePlate: [<LicensePlate>{}, requireLicensePlate],
    confirmRights: [false, Validators.requiredTrue],
  });

  enterCheck(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.next();
    }
  }

  next(): void {
    this.licensePlateForm.markAllAsTouched();
    this.licensePlateInputComponent.markAllAsTouched();
    if (this.licensePlateForm.valid) {
      const licensePlate = this.licensePlateForm.value.licensePlate;
      this.onboardingService
        .getOnboardingSession(licensePlate as LicensePlate)
        .pipe(showSpinner(), take(1))
        .subscribe({
          next: () => {
            this.stepperComponent?.next();
          },
          error: (error) => {
            if (error.status === 429) {
              this.toastService.add({
                message: error.error.message ?? this.translateService.instant('Common.Errors.UnknownError'),
                type: 'error',
              });
            } else {
              this.toastService.add({
                message: this.translateService.instant('LogIn.CouldNotSendEmail'),
                type: 'error',
              });
            }
          },
        });
    }
  }
}
